import { getTravellerContactInfoValues } from '@shared/lib/passengers';
import { buildRefundPassengers } from './buildRefundPassengers';
const mapTravellerToValue = (traveller) => ({
    id: traveller.id,
    type: traveller.type,
    supplierTravellerType: traveller.supplierTravellerType,
    linkedTraveller: traveller.linkedTraveller
        ? {
            id: traveller.linkedTraveller.id,
            type: traveller.linkedTraveller.type,
            values: getTravellerContactInfoValues(traveller.linkedTraveller.values)
        }
        : undefined,
    values: getTravellerContactInfoValues(traveller.values)
});
/** Приводит `RefundTravellerFragment` к `TravellerValue` (как `getTravellersValues` для заказа). */
export const mapRefundTravellersToValues = (travellers) => travellers.filter((traveller) => traveller !== null).map(mapTravellerToValue);
/**
 * Строит refund-модель пассажиров для страницы заявки (без Redux state).
 *
 * Все пассажиры считаются выбранными.
 * Дальше переиспользуется `buildRefundPassengers`.
 *
 * @param travellers - пассажиры из `getLastRefund().travellers`.
 */
export const buildRequestRefundPassengers = (travellers) => {
    const travellerValues = mapRefundTravellersToValues(travellers);
    const selection = travellerValues.reduce((acc, traveller) => {
        acc[traveller.id] = true;
        return acc;
    }, {});
    return buildRefundPassengers(travellerValues, selection);
};
